<mat-card class="register-card">
    <mat-card-header>
        <mat-card-title>Site Registration</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <!-- User Information -->
            <h3>User Information</h3>
            <div formGroupName="user">
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName" (change)="userUpdate()">
                    <mat-error *ngIf="registerForm.get('user.firstName')?.hasError('required')">First Name is
                        required</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName" (change)="userUpdate()">
                    <mat-error *ngIf="registerForm.get('user.lastName')?.hasError('required')">Last Name is
                        required</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" (change)="userUpdate()">
                    <mat-error *ngIf="registerForm.get('user.title')?.hasError('required')">Title is
                        required</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask (change)="userUpdate()">
                    <mat-error *ngIf="registerForm.get('user.phone')?.hasError('required')">Phone is
                        required</mat-error>
                    <mat-error *ngIf="registerForm.get('user.phone')?.hasError('pattern')">Enter a valid phone number
                        (e.g., (123) 456-7890)</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" type="email" (change)="userUpdate()">
                    <mat-error *ngIf="registerForm.get('user.email')?.hasError('required')">Email is
                        required</mat-error>
                    <mat-error *ngIf="registerForm.get('user.email')?.hasError('email')">Enter a valid email</mat-error>
                </mat-form-field>
            </div>

            <!-- Sales Contact Information -->
            
            
            <h3>Sales Contact Information</h3>
            
            <div formGroupName="sales">
                <mat-checkbox formControlName="salesMatchesUser" (change)="toggleSalesUser()">Same as user information</mat-checkbox>
                <div class="salesUserInput" *ngIf="!salesMatchesUser">

                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="firstName">
                        <mat-error *ngIf="registerForm.get('sales.firstName')?.hasError('required')">First Name is
                            required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="lastName">
                        <mat-error *ngIf="registerForm.get('sales.lastName')?.hasError('required')">Last Name is
                            required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="title">
                        <mat-error *ngIf="registerForm.get('sales.title')?.hasError('required')">Title is
                            required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                        <mat-error *ngIf="registerForm.get('sales.phone')?.hasError('required')">Phone is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('sales.phone')?.hasError('pattern')">Enter a valid phone number
                            (e.g., (123) 456-7890)</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="email">
                        <mat-error *ngIf="registerForm.get('sales.email')?.hasError('required')">Email is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('sales.email')?.hasError('email')">Enter a valid
                            email</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Theaters -->
            <h3>Theaters</h3>
            <div formArrayName="theaters">
                <div *ngFor="let theater of theaters.controls; let i=index" [formGroupName]="i">
                    <h4>Theater {{ i + 1 }}</h4>
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name">
                        <mat-error *ngIf="theaters.controls[i].get('name')?.hasError('required')">Name is
                            required</mat-error>
                    </mat-form-field>
                    <div formGroupName="address">
                        <mat-form-field>
                            <mat-label>Address</mat-label>
                            <input matInput formControlName="adress">
                            <mat-error *ngIf="theaters.controls[i].get('address.adress')?.hasError('required')">Address
                                is required</mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city">
                            <mat-error *ngIf="theaters.controls[i].get('address.city')?.hasError('required')">City is
                                required</mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>State</mat-label>
                            <input matInput formControlName="state">
                            <mat-error *ngIf="theaters.controls[i].get('address.state')?.hasError('required')">State is
                                required</mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>ZIP</mat-label>
                            <input matInput formControlName="zip" placeholder="12345">
                            <mat-error *ngIf="theaters.controls[i].get('address.zip')?.hasError('required')">ZIP is
                                required</mat-error>
                            <mat-error *ngIf="theaters.controls[i].get('address.zip')?.hasError('pattern')">Enter a
                                valid 5-digit ZIP code</mat-error>
                        </mat-form-field>
                    </div>
                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                        <mat-error *ngIf="theaters.controls[i].get('phone')?.hasError('required')">Phone is
                            required</mat-error>
                        <mat-error *ngIf="theaters.controls[i].get('phone')?.hasError('pattern')">Enter a valid phone
                            number (e.g., (123) 456-7890)</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Preferred Format</mat-label>
                        <mat-select formControlName="preferredFormat">
                            <mat-option value="Rights only —Self Supplied">Rights only —Self Supplied</mat-option>
                            <mat-option value="DCP">DCP</mat-option>
                            <mat-option value="35mm">35mm</mat-option>
                        </mat-select>
                        <mat-error *ngIf="theaters.controls[i].get('preferredFormat')?.hasError('required')">Preferred
                            Format is required</mat-error>
                    </mat-form-field>
                    <mat-checkbox formControlName="admissionCharges">Admission Charges</mat-checkbox>
                    <br>
                    <button mat-button color="warn" (click)="removeTheater(i)" *ngIf="theaters.length > 0">Remove
                        Theater</button>
                </div>
            </div>
            <button mat-button color="primary" type="button" (click)="addTheater()">+ Add Theater</button>

            <!-- Password -->
            <mat-form-field>
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" type="password" (input)="onPasswordInput()">
                <mat-error *ngIf="registerForm.get('password')?.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="registerForm.get('password')?.hasError('minlength')">Password must be at least 6
                    characters</mat-error>
            </mat-form-field>

            <!-- Verify Password -->
            <mat-form-field>
                <mat-label>Verify Password</mat-label>
                <input matInput formControlName="confirmPassword" type="password" (input)="onPasswordInput()">
                <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('required')">Password is
                    required</mat-error>
                <mat-error *ngIf="registerForm.hasError('passwordMismatch')">
                    Passwords do not match
                </mat-error>
            </mat-form-field>
            <mat-error *ngIf="registerForm.hasError('passwordMismatch')">
                Passwords do not match
            </mat-error>
            

            <!-- Submit -->
            <mat-error *ngIf="error">{{ error }}</mat-error>
            <button mat-raised-button color="primary" type="submit">Register</button>
            <!-- [disabled]="registerForm.invalid" -->
        </form>
    </mat-card-content>
</mat-card>